import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import notify from './plugins/notify'
import router from './router'
import store from '@/store'
import { startSessionWatch } from '@/utils/session'
Vue.config.productionTip = false
Vue.use(notify)

new Vue({
    vuetify,
    router,
    store,
    render: h => h(App)
}).$mount('#app')

startSessionWatch()
